// extracted by mini-css-extract-plugin
export default {"boardWrap":"Boards_boardWrap__oDR6A","tasksColumn":"Boards_tasksColumn__gufKI","boardTitle":"Boards_boardTitle__MvsFJ","tasks_content":"Boards_tasks_content__G5gGv"};